import { CurrencyPipe, DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { GlobalService } from '../services/global.service';
import { HoursPipe } from './hours.pipe';
import { MinutesPipe } from './minutes.pipe';

@Pipe({
    name: 'getValue',
    standalone: false
})
export class GetValuePipe implements PipeTransform {

  constructor(
    public _gS: GlobalService,
    private _datePipe: DatePipe,
		private _currencyPipe: CurrencyPipe,
		private hoursPipe: HoursPipe,
		private minutesPipe: MinutesPipe,
  ) {}

  transform(scn: any, head: any, numb?: any): any {
    if (head.type == 'back_translate') {
      let value = scn[head.value + '_' + this._gS.getLenguage()];
      return value || value == 0 ? value : '--'
    } else if (head.type == 'list' || head.type == 'list_back_translate') {
        if (numb) {
            return scn[head.value]
        } else {
            if (head.type == 'list_back_translate') {
                var a = scn[head.list + '_' + this._gS.getLenguage()]
                return a ? a : '--'
            } else {
                var a = scn[head.list]
                return a ? a : '--'
            }
        }
        return scn[head.value + '_' + this._gS.getLenguage()]
    } else if (head.type == 'Minutes') {
        if (!scn[head.value]) {
            return '--:--'
        }
        var minutes = Math.floor(scn[head.value] / 60);
        var seconds = scn[head.value] - minutes * 60;
        var retval = minutes.toString() + ":" + seconds.toString()
        if (seconds < 10) {
            retval = minutes.toString() + ":0" + seconds.toString()
        }
        return retval
    } else if (head.type == 'hours') {
        if (!scn[head.value]) {
            return '--:--'
        }
        return this.hoursPipe.transform(Number(scn[head.value]));

    } else if (head.type == 'minutes-pipe') {
        if (!scn[head.value]) {
            return '--:--'
        }
        return this.minutesPipe.transform(Number(scn[head.value]));

    } else if (head.type == 'number') {
        var a = scn[head.value]
        return a ? a : 0;
    } else if (head.type == 'percent') {
        var a = scn[head.value]
        return a ? parseFloat(a).toFixed(2) + '%' : '0%';
    } else if (head.type == 'date') {
        if (!scn[head.value]) {
            return '--/--/----'
        }
        return this._datePipe.transform(scn[head.value], 'MMM-dd-yyyy')

    } else if (head.type == 'dateDay') {
        if (!scn[head.value]) {
            return '--/--/----'
        }
        return this._datePipe.transform(scn[head.value], 'EEEE')

    } else if (head.type == 'time') {
        if (!scn[head.value]) {
            return '--:-- --'
        }
        let time = scn[head.value];
        return this._datePipe.transform(this._gS.getStaticDateHour(time), 'h:mm a')
    } else if (head.type == 'currency') {
        let value = scn[head.value];
        return value || value == 0 ? this._currencyPipe.transform(value, '$') : '--';

    } else if (head.type == 'date_time') {
        if (!scn[head.value]) {
            return '--:-- --'
        }
        let date_time = scn[head.value];
        return this._datePipe.transform(this._gS.getStaticDateHour(date_time), 'MMM-dd-yyyy h:mm a')
    } else if (head.type == 'ok_field') {
        let value = scn[head.value];
        return value ? 'OK' : '--'
    } else if (head.type == 'link') {
        let value = scn[head.value];
        return value || value == 0 ? value : ''
    }
    else if (head.type == 'progress_bar') {
        let value = scn[head.value];
        return value || value == 0 ? value : ''
    }
    else if (head.type == 'bothBack_translate') {
        let value = scn[head.value + '_' + this._gS.getLenguage()];
        if (value == null || value == undefined) value = scn[head.value];
        return value || value == 0 ? value : '--';
    }
    else if (!head.type) {
        var a = scn[head.value]
        return a ? a : '--'
    }
  }

}
